import React from 'react';
import { SwitchRoute } from '../../../Components/Route/SwitchRoute';
import { LearningAndDevelopmentRoutes } from '../../../routes/HomeRoutes/LearningAndDevelopmentRoutes';

export const LearningAndDevelopmentLayout = () => <SwitchRoute routes={LearningAndDevelopmentRoutes} />;
